export const iconFontAwesomeMediaplaybackVolumeHigh = (
	<i className="fa-solid fa-volume-high"></i>
);
